
const initialState = {
    data: null,
    loading: false,
    error: null,
}
const urlsReducer = (state = initialState, action) => {
    switch (action.type) {
        case "URL_REQUEST_LOADING":
            return { ...state, loading: true, error: null };
          case "URL_REQUEST_SUCCESS":
            return { ...state, loading: false, data: action.payload.data };
          case "URL_REQUEST_ERROR":
            return { ...state, loading: false, error: action.payload, status: action?.status };
          case "URL_EXIT":
            return {...initialState}
        default:
            return state;
    }
}
export default urlsReducer